function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight13X10 = function SvgArrowRight13X10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6.649 8.156 2.744-2.744H0V3.866h9.393L6.649 1.121 7.731 0l4.639 4.639-4.639 4.638Z",
    style: {
      isolation: "isolate"
    }
  }));
};
export default SvgArrowRight13X10;